import React, { useContext } from 'react';
import clsx from 'clsx';
import Select from 'react-select';
import { StatsSelector } from './StatsSelector';
import { Chart } from './Chart';
import { PeriodLabelsMap, periods } from '../helpers';
import { ChartSkeleton, SkeletonLoader } from './Skeleton';
import { useAnalyticsContext } from '../AnalyticsProvider';
import { AppDataContext } from 'contexts/appData';

export const Stats = () => {
  const { activePeriod, setActivePeriod, isLoading, isFetching } = useAnalyticsContext();
  const { langs } = useContext(AppDataContext);

  if (isLoading) return <SkeletonLoader />;

  return (
    <div className="bg-white border-radius-md-12">
      <div
        className="d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap gap-16px p-16px p-md-20px"
        style={{ borderBottom: '1px solid #EEE' }}
      >
        <div>
          <div className="font-bold mb-4px" style={{ fontSize: 16, color: '#0A0A0A' }}>
            {langs?.Statistics}
          </div>
          <div style={{ color: '#737373', fontSize: 12 }}>{langs?.[PeriodLabelsMap[activePeriod]]}</div>
        </div>

        <div style={{ width: '180px' }}>
          <Select
            name="Period"
            className="sg-selectbox-container"
            classNamePrefix="sg-selectbox"
            classNames={{ control: (classes) => clsx(classes, 'h-36px'), valueContainer: (classes) => clsx(classes, 'px-12px py-0') }}
            // components={{ Option: CustomSelectOption }}
            formatOptionLabel={(option) => langs?.[option.label]}
            options={periods}
            onChange={(item) => {
              setActivePeriod(item.value);
            }}
            value={periods.find((item) => item.value === activePeriod)}
          />
        </div>
      </div>

      <StatsSelector />
      {isFetching ? <ChartSkeleton /> : <Chart />}
    </div>
  );
};
